import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import clsx from 'clsx';

import { MessengerIcon } from '../Icons/MessengerIcon';
import { useAppConfigContext } from '../../hooks/useAppConfigContext';
import { DialogOption } from '../../utils/common.types';

import styles from './Footer.module.css';
import { Privacy } from '../Privacy&Personal/Privacy';
import { PersonalData } from '../Privacy&Personal/PersonalData';
import { Modal } from '../Modal/Modal';

export const Footer = () => {
  const config = useAppConfigContext();
  const [open, setOpen] = useState(false);
  const [dialogOption, setDialogOption] = useState<DialogOption>(null);
  const [fixed, setFixed] = useState(false);
  const location = useLocation();

  const openDialog = (option: DialogOption) => {
    setOpen(true);
    setDialogOption(option);
  };

  const closeDialog = () => {
    setOpen(false);
    setDialogOption(null);
  };

  useEffect(() => {
    if (location.pathname === '/') {
      setFixed(true);
    } else {
      setFixed(false);
    }
  }, [location.pathname]);

  return (
    <footer className={clsx(styles.container, fixed && styles.fixedContainer)}>
      <section className={styles.brandSection}>
        <div className={styles.sectionText}>
          <h3 className="font-specialGothic font-normal">{config.logo}</h3>
          <p>
            {config.organization} | {config.OGRN}
          </p>
        </div>
      </section>
      <section className={styles.personalSection}>
        <div className={styles.sectionText}>
          <button
            className={styles.growHover}
            onClick={() => openDialog('personalData')}
            type="button"
          >
            Политика обработки персональных данных
          </button>
        </div>
      </section>
      <section className={styles.termslSection}>
        <div className={styles.sectionText}>
          <button
            className={styles.growHover}
            onClick={() => openDialog('privacy')}
            type="button"
          >
            Политика конфиденциальности
          </button>
        </div>
      </section>
      <section className={styles.iconsSection}>
        <div className={styles.bottomContainer}>
          <nav>
            <ul className={styles.navList}>
              <li>
                <MessengerIcon key="vk" type="vk" className={styles.text} />
              </li>
              <li>
                <MessengerIcon
                  key="telegram"
                  type="telegram"
                  className={styles.text}
                />
              </li>
            </ul>
          </nav>
        </div>
      </section>
      <Modal
        open={open}
        onClose={closeDialog}
        containerStyles={styles.modalBox}
      >
        {dialogOption === 'privacy' && <Privacy />}
        {dialogOption === 'personalData' && <PersonalData />}
      </Modal>
    </footer>
  );
};
